<template>
  <b-modal id="ModalRefundBank" size="md" ref="ModalRefundBank" >
    <div align="center">
      <b-form-group label-cols="2" horizontal label="예금주">
        <b-form-input v-model="bankInfo.name"></b-form-input>
      </b-form-group>
      <b-form-group label-cols="2" horizontal label="은행">
        <v-select v-model="bankInfo.bank" placeholder="은행선택" :options="optionsType"/>
      </b-form-group>
      <b-form-group label-cols="2" horizontal label="계좌번호">
        <b-form-input v-model="bankInfo.account_no"></b-form-input>
      </b-form-group>
    </div>
    <template slot="modal-footer">
      <div class="mt-3 text-center">
        <b-button class="mb-1 ml-1" @click="cancel" variant="outline-primary">취소</b-button>
        <b-button class="mb-1 ml-1" @click="confirm" variant="primary">저장</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    components: {
      'v-select': vSelect,
    },
    props: [],
    name: "ModalRefundBank",
    data() {
      return {
        bankInfo : {
          name: null,
          account_no: null,
          bank: null,
        },
        optionsType: [
          {label: '신한은행', text:'신한은행'},
          {label: '우리은행', text:'우리은행'},
          {label: '국민은행', text:'국민은행'},
          {label: '기업은행', text:'기업은행'},
          {label: '카카오뱅크', text:'카카오뱅크'},
        ]
      }
    },
    methods: {
      open() {
        this.$refs['ModalRefundBank'].show()
      },

      confirm() {
        if( this.bankInfo.name === null ) {
          alert('예금주 명을 입력해주세요')
          return false
        } else if( this.bankInfo.bank === null ) {
          alert('은행을 선택해주세요')
          return false
        } else if ( this.bankInfo.account_no === null ) {
          alert('입금계좌번호를 입력해주세요');
          return false
        } else {
          this.$emit('confirm', this.bankInfo)
          this.$refs['ModalRefundBank'].hide()
        }
      },

      cancel() {
        this.memo = ''
        this.$refs['ModalRefundBank'].hide()
      }

    },

  }
</script>
